/**
 * @generated SignedSource<<6afcce5622630b5660e171d185f9ba2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsAmpEnabledArticle$data = {
  readonly disableOffPlatformContent: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly entityId: string;
  readonly published: boolean;
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly sponsorType: string | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly sponsor: {
      readonly entityId: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPlusArticle" | "helpersCheckIsPostiesArticle">;
  readonly " $fragmentType": "helpersCheckIsAmpEnabledArticle";
};
export type helpersCheckIsAmpEnabledArticle$key = {
  readonly " $data"?: helpersCheckIsAmpEnabledArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsAmpEnabledArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsAmpEnabledArticle"
};

(node as any).hash = "87de33a3df0306edd5ce46f27e278f4a";

export default node;
